import { useTranslation } from '../contexts/TranslationContext'
import { ui } from '../styles/ui'

const STATUS_STYLES = {
  completed: ui.badges.success,
  done: ui.badges.success,
  skipped: ui.badges.success,
  pending: ui.badges.info,
  processing: ui.badges.warning,
  failed: ui.badges.danger,
}

const STATUS_ICON = {
  completed: '✓',
  done: '✓',
  skipped: '→',
  pending: null,
  processing: null,
  failed: '✕',
}

export default function StatusBadge({ label, status }) {
  const { t } = useTranslation()
  const raw = String(status ?? '').trim().toLowerCase()
  const normalized = raw === '' || raw === 'null' || raw === 'undefined'
    ? 'pending'
    : raw === 'done'
      ? 'completed'
      : raw
  const styleClass = STATUS_STYLES[normalized] || ui.badges.neutral
  const icon = STATUS_ICON[normalized] ?? null
  const isInProgress = normalized === 'processing' || normalized === 'pending'
  const displayStatus = normalized === 'completed' ? 'done' : normalized
  const translatedStatus = (() => {
    switch (displayStatus) {
      case 'done':
        return t('status.done', 'Done')
      case 'skipped':
        return t('status.skipped', 'Skipped')
      case 'pending':
        return t('status.pending', 'Pending')
      case 'processing':
        return t('status.processing', 'Processing')
      case 'failed':
        return t('status.failed', 'Failed')
      default:
        return displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)
    }
  })()

  return (
    <span className={`${ui.badges.base} ${styleClass}`}>
      {icon && <span className="text-xs leading-none">{icon}</span>}
      {isInProgress && (
        <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
      <span>
        {label}:{' '}
        {translatedStatus}
      </span>
    </span>
  )
}
